<template>
    <div ref="box">
        <!-- 头部 -->
        <div class="bar-manager-header">
            <bar-header
                @refresh="refresh"
                @addAllRouterRemote="addAllRouterRemote"
            ></bar-header>
        </div>
        <!-- 表格部分 -->
        <div class="table-content">
            <bar-table-list
                :table-list="tableData.list"
                ref="tableList"
                @addAllRouterRemote="addAllRouterRemote"
                @deleteAllRouter="deleteAllRouter"
                @pagechange="getBarList"
                :loading="tableLoading"
                :total="parseInt(total)"
                :page="parseInt(page)"
            ></bar-table-list>
        </div>
    </div>
</template>

<script>
// 头部
import BarHeader from "../../barHeader";
// 网吧列表
import BarTableList from "../../barTableList";

import { getBarList, deleteRouterBatch } from "@/requests/bar";
import { mapActions } from "vuex";

export default {
    name: "allBar",
    components: {
        BarHeader,
        BarTableList
    },
    data() {
        return {
            total: 0,
            page: 1,
            tableData: {
                list: []
            },
            groupId: "",
            tableLoading: false
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.groupId = vm.$route.params.id;
            vm.getBarList(1);
        });
    },
    watch: {
        /* eslint-disable */
        $route(to, from) {
            this.groupId = to.params.id;
            this.getBarList(1);
        }
    },
    methods: {
        ...mapActions(["user/actionsSetSelectedBarGroupName"]),
        // 获取所有网吧列表
        async getBarList(pageNum) {
            this.tableData.list = [];
            this.tableLoading = true;
            let res = await getBarList({
                pageNum,
                pageSize: 20,
                groupId: this.groupId
            });
            this.tableData.list = res.records;
            this.total = parseInt(res.total);
            this.page = parseInt(res.current);
            this.tableLoading = false;
            this["user/actionsSetSelectedBarGroupName"](this.groupId);
        },
        addAllRouterRemote() {
            if (this.$refs.tableList.selectedBarIds().length == 0) {
                return window.$Message.show({
                    title: "提示",
                    type: "info",
                    msg: "请选择选择网吧"
                });
            }
            window.$modal.setRouterRemoteModal.show(
                { barId: this.$refs.tableList.selectedBarIds().join(",") },
                0,
                true
            );
        },
        deleteAllRouter() {
            if (this.$refs.tableList.selectedBarIds().length == 0) {
                return window.$Message.show({
                    title: "提示",
                    type: "info",
                    msg: "请选择选择网吧"
                });
            }
            window.$Message.show({
                title: "删除全部路由",
                type: "info",
                msg: "确认删除所有选中的网吧吗？",
                cancleBtn: true,
                confirmFn: async () => {
                    let res = await deleteRouterBatch({
                        barId: this.$refs.tableList.selectedBarIds().join(",")
                    });
                    if (res.code === 200) {
                        window.$Message.hide();
                        this.getBarList(1);
                    } else {
                        window.$Message.hide();
                        setTimeout(() => {
                            window.$Message.show({
                                title: "删除全部路由",
                                type: "error",
                                msg: res.msg,
                                confirmFn: () => {
                                    window.$Message.hide();
                                    window.$Message.confirmFn = null;
                                }
                            });
                        }, 100);
                    }
                }
            });
        },
        async refresh() {
            await this.getBarList(this.page);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.bar-manager-header {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d9dee4;
}
.table-content {
    padding-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
}
</style>
